import React, { useEffect, useState } from 'react';
import { CheckIn } from '../types';
import { getUserCheckIns } from '../firebase/firestore';
import { formatTurkeyDate } from '../utils';

interface CheckInHistoryProps {
  userId: string;
}

const CheckInHistory: React.FC<CheckInHistoryProps> = ({ userId }) => {
  const [checkIns, setCheckIns] = useState<CheckIn[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const loadCheckIns = async () => {
      try {
        const history = await getUserCheckIns(userId);
        setCheckIns(history.slice(0, 10)); // Show last 10 check-ins
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadCheckIns();
  }, [userId]);

  if (loading) {
    return (
      <div className="flex justify-center py-4">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-4">
        <p className="text-red-600">Giriş geçmişi yüklenirken hata: {error}</p>
      </div>
    );
  }

  if (checkIns.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-gray-500">Giriş geçmişi mevcut değil</p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <div className="flow-root">
        <ul className="-my-5 divide-y divide-gray-200">
          {checkIns.map((checkIn) => (
            <li key={checkIn.id} className="py-4">
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center bg-green-100 text-green-800">
                    <span className="text-sm font-medium">✓</span>
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900">
                    Günlük Giriş
                  </p>
                  <p className="text-sm text-gray-500">
                    {formatTurkeyDate(checkIn.timestamp)}
                  </p>
                </div>
                <div className="flex-shrink-0 text-sm text-gray-500">
                  {checkIn.distance.toFixed(2)}km uzakta
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CheckInHistory; 